import type { ReadonlyDeep } from 'type-fest';

import {
  getFragmentData,
  ResolvableMissionTypeInput,
} from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

import { codingConfigForm2ApiMapper } from '../../CodingConfig/mappers/coding-config.form2api.mapper';
import { resolvableServiceUsageForm2ApiMapper } from '../../ResolvableServiceUsage/mappers/resolvable-service-usage.form2api.mapper';
import { ResolvableServiceUsageForm_ResolvableServiceUsage_Fragment } from '../../ResolvableServiceUsage/fragments/resolvable-service-usage.fragment';
import { ResolvableServiceUsagesGroupForm_ResolvableServiceUsagesGroup_Fragment } from '../../ResolvableServiceUsage/fragments/resolvable-service-usages-group.fragment';
import { quotationHeaderForm2ApiMapper } from '../../QuotationHeader/mappers/quotation-header.form2api.mapper';
import { QuotationHeaderForm_QuotationHeader_Fragment } from '../../QuotationHeader/fragments/quotation-header.fragment';

import type { ResolvableMissionTypeForm_ResolvableMissionType } from '../fragments/resolvable-mission-type.fragment';
import type { ResolvableMissionTypeInput as IResolvableMissionTypeInput } from '../hooks/useCreateResolvableMissionTypeMutation.hook';

export function resolvableMissionTypeForm2ApiMapper(
  resolvableMissionType: ReadonlyDeep<ResolvableMissionTypeForm_ResolvableMissionType>,
): ReadonlyDeep<IResolvableMissionTypeInput> {
  const cleanServiceUsagesGroups = getFragmentData(
    ResolvableServiceUsagesGroupForm_ResolvableServiceUsagesGroup_Fragment,
    resolvableMissionType.serviceUsagesGroups,
  ).map((group) => ({
    _id: group._id,
    groupingMode: group.groupingMode,
    index: group.index,
    isOptional: group.isOptional,
    label: group.label,
    serviceUsages: getFragmentData(
      ResolvableServiceUsageForm_ResolvableServiceUsage_Fragment,
      group.serviceUsages,
    ).map(resolvableServiceUsageForm2ApiMapper),
  }));

  const resolvableMissionTypeInput = pruneInput(
    resolvableMissionType,
    ResolvableMissionTypeInput,
  );

  const quotationHeader = getFragmentData(
    QuotationHeaderForm_QuotationHeader_Fragment,
    resolvableMissionType.quotationHeader,
  );

  return {
    ...resolvableMissionTypeInput,
    serviceUsagesGroups: cleanServiceUsagesGroups,
    codingConfig: codingConfigForm2ApiMapper(
      resolvableMissionType.codingConfig,
    ),
    quotationHeader: quotationHeaderForm2ApiMapper(quotationHeader),
    reportTemplateIds: resolvableMissionTypeInput.reportTemplateIds ?? null,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    quotationTemplateId: resolvableMissionTypeInput.quotationTemplateId || null,
    allowedFileCategoryIds:
      resolvableMissionTypeInput.allowedFileCategoryIds ?? null,
  };
}
